import { NumberComparisonOperator } from "@redotech/redo-flows-core-common/comparison-operators";
import { numberComparisonToLabel } from "@redotech/redo-flows-core-schema-common/expressions/number-expression";
import { T } from "@redotech/redo-i18n";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";

export const IntegerComparisonDetails = memo(function IntegerComparisonDetails({
  field,
  matchType,
  matchValue,
  prefix,
  suffix,
}: {
  field: string;
  matchType?: NumberComparisonOperator;
  matchValue?: number;
  prefix?: string;
  suffix?: string;
}) {
  const operatorLabel = matchType ? numberComparisonToLabel[matchType] : "";
  const comparisonValue = `${prefix ?? ""}${matchValue != null ? matchValue.toString() : ""}${suffix ?? ""}`;

  return (
    <T>
      If <Text fontWeight="semibold">{field}</Text> is{" "}
      <Text>{operatorLabel}</Text>{" "}
      <Text fontWeight="semibold">{comparisonValue}</Text>
    </T>
  );
});
